import { useState } from 'react';
import { FIX_SENTENCE_START_TIME } from '../utils/const';

// 本カスタムフックの返り値
export type UseTrainingJumpSentenceValue = {
  isVisible: boolean;
  updateIsVisible: (currenTime: number) => void;
};

const useTrainingJumpSentence = (
  firstSentenceStartTime: number,
  endTime: number, // センテンスの終了時間
): UseTrainingJumpSentenceValue => {
  // sentenceを表示するかどうか
  const [isVisible, setIsVisible] = useState<boolean>(false);

  /**
   * isVisibleを更新する
   * @param currentTime 再生時間
   */
  const updateIsVisible = (currentTime: number) => {
    // Safari(iOS、macOS)で、センテンスが点滅しないように、開始時間を早める
    const startTime = firstSentenceStartTime - FIX_SENTENCE_START_TIME;

    // 最初のセンテンスの開始時間より前
    if (currentTime < startTime) {
      setIsVisible(false);

      return;
    }

    const value = currentTime <= endTime;
    setIsVisible(value);
  };

  return {
    isVisible,
    updateIsVisible,
  };
};

export default useTrainingJumpSentence;
